import React, { useState } from "react";
import axios from "../../axios";
import { toast } from "react-toastify";
import Loader from "../loader/Loader";

const AddHowToUseVideo = () => {
  const [titleAl, setTitleAl] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleSr, setTitleSr] = useState("");
  const [video, setVideo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const videoChange = (e) => {
    const file = e.target.files[0];
    setVideo(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!video) {
      toast.error("Please select a video file.");
      return;
    }

    const formData = new FormData();
    formData.append("title_al", titleAl || "");
    formData.append("title_en", titleEn || "");
    formData.append("title_sr", titleSr || "");
    formData.append("video", video);

    try {
      setIsLoading(true);
      await axios.post("how-to-use-videos", formData);
      toast.success("Video has been added successfully!");
      window.history.back();
    } catch (err) {
      toast.error("Something went wrong!");
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="privacy_policy p-5 text-left">
      <div className="page-title">
        <h1>Add Video</h1>
      </div>
      {isLoading && <Loader />}
      <form onSubmit={handleSubmit}>
        <label>Title Albanian (optional)</label>
        <input
          type="text"
          value={titleAl}
          onChange={(e) => setTitleAl(e.target.value)}
          placeholder="Titulli (AL)"
        />

        <label>Title English (optional)</label>
        <input
          type="text"
          value={titleEn}
          onChange={(e) => setTitleEn(e.target.value)}
          placeholder="Title (EN)"
        />

        <label>Title Serbian (optional)</label>
        <input
          type="text"
          value={titleSr}
          onChange={(e) => setTitleSr(e.target.value)}
          placeholder="Naslov (SR)"
        />

        <label>Upload video</label>
        <input type="file" accept="video/*" onChange={videoChange} />

        <button type="submit">Add</button>
      </form>
    </div>
  );
};

export default AddHowToUseVideo;

